export default __webpack_public_path__ + "static/media/WildCard.fbe9e113.png";